import { defineComponent as _defineComponent } from 'vue'
import { useLazyAsyncData, useNuxtApp } from '#app'
import { setupLocations } from './service'


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchResultsPopularLocations',
  setup(__props) {

const ctx = useNuxtApp()
const { $route } = ctx
const lang = $route.params.lang || 'en-gb'

const { data: popularLocations } = useLazyAsyncData(
  `popularLocations-${$route.fullPath}`,
  () => setupLocations(lang, ctx),
)

return { __sfc: true,ctx, $route, lang, popularLocations }
}

})